// Service hook (TS-2.5.01, Resource Accessor layer) - GET /api/projects/owners, the same read
// projects/hooks/useOwnerSuggestions.ts wraps for the project form's Owner field. Duplicated here
// rather than imported across the feature boundary, on the codebase's existing precedent (see
// admin/lib/adminFormat.ts's own header): a product's owner fields are free text on the same D-249
// rule, and the suggestions this admin form offers are a same-session convenience list, not a
// vocabulary the save path validates against - a failed fetch must not block the field.
import { useEffect, useState } from "react";
import type { ProjectOwnerSummary } from "../../../api/generated/contracts";
import { portfolioDataApi } from "../../../api/portfolioData";

export interface UseOwnerSuggestionsResult {
  readonly owners: readonly ProjectOwnerSummary[];
}

export function useOwnerSuggestions(): UseOwnerSuggestionsResult {
  const [owners, setOwners] = useState<readonly ProjectOwnerSummary[]>([]);

  useEffect(() => {
    let cancelled = false;

    void portfolioDataApi
      .listOwners()
      .then((next) => {
        if (!cancelled) setOwners(next);
      })
      .catch(() => {
        // Non-fatal: the owner fields stay usable free-text inputs either way.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { owners };
}
